import React from 'react';
import Modal from 'react-bootstrap/Modal';
import styles from './styles/styles.module.css';

const VisitorProfile: React.FC = () => {
  return (
    <Modal show={false} centered backdrop="static">
      <div className={styles.innerContainer}>
        <div className={styles.leftContainer}>
          <div className={styles.profilePictureContainer}>
            <img
              src="/assets/ProfilePlaceholder.png"
              alt="Profile Placeholder"
              className={styles.profileImage}
            />
            <p className={styles.name}>Ana Lucero</p>
            <p className={styles.role}>Staff</p>
          </div>
          <p className={styles.licensePlate}>License Plate: 44EMR</p>
        </div>
        <div></div>
      </div>
    </Modal>
  );
};

export default VisitorProfile;
